import { BiAnalyse } from 'react-icons/bi';

function Logo() {
  return (
    <h1 style={{ display: 'flex', alignItems: 'center' }}>
      IJOB
      <BiAnalyse />
    </h1>
  );
}

export default Logo;
